
window.addEventListener('popstate', function() {
    setTimeout(async () => {
        const path = getCurrentDirectoryPath();
        directoryFilesCount = await countFilesWithWebDav();
    }, 1000);
});

window.addEventListener('hashchange', function() {
    setTimeout(async () => {
        const path = getCurrentDirectoryPath();
        directoryFilesCount = await countFilesWithWebDav();
    }, 1000);
});

document.addEventListener('click', function(e) {
    const navLink = e.target.closest('a[href], button[data-cy-files-list-row-name-link], .files-list__row-name-link');
    if (navLink) {
        const row = navLink.closest('tr.files-list__row, tr[data-cy-files-list-row]');
        if (row) {
            const folderIcon = row.querySelector('.folder-icon, .material-design-icon.folder-icon');
            if (folderIcon) {
                setTimeout(async () => {
                    const path = getCurrentDirectoryPath();
                    directoryFilesCount = await countFilesWithWebDav();
                }, 1500);
            }
        }
    }
});import { showError, showSuccess } from '@nextcloud/dialogs'
import { generateUrl } from '@nextcloud/router'
import axios from '@nextcloud/axios'
import translations from './translations'

let errorShown = false;
let lastAttemptedFile = null;
let directoryFilesCount = null;
let currentDirectory = null;

function getUserLanguage() {
    let lang = 'en';
    
    if (typeof OC !== 'undefined' && OC.getLocale) {
        lang = OC.getLocale().substring(0, 2).toLowerCase();
    }
    
    else if (document.documentElement && document.documentElement.lang) {
        lang = document.documentElement.lang.substring(0, 2).toLowerCase();
    }
    
    else {
        lang = (navigator.language || navigator.userLanguage || 'en').substring(0, 2).toLowerCase();
    }
    
    if (lang === 'nb' || lang === 'nn') {
        lang = 'no';
    }
    
    return lang;
}

// Function to check for pending move operations - just add this to your existing script
function hasPendingOperations() {
    // Count checked checkboxes - if more than 1, there are pending operations
    const checkedBoxes = document.querySelectorAll('.checkbox-radio-switch--checked input[type="checkbox"]');
    
    if (checkedBoxes.length > 1) {
        console.log('Found multiple checked files:', checkedBoxes.length);
        return true;
    }
    
    return false;
}

function formatBytes(bytes) {
    if (typeof OC !== 'undefined' && OC.L10N && typeof OC.L10N.formatFileSize === 'function') {
        return OC.L10N.formatFileSize(bytes);
    }
    if (typeof OC !== 'undefined' && typeof OC.humanFileSize === 'function') {
        return OC.humanFileSize(bytes);
    }
    if (!bytes || bytes <= 0) return '0 KB';
    if (bytes > 0 && bytes < 1024) return '< 1 KB';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const val = (bytes / Math.pow(k, i)).toFixed(i > 1 ? 1 : 0);
    return val + ' ' + sizes[i];
}

function parseSizeToBytes(sizeStr) {
    if (!sizeStr) return 0;
    const clean = sizeStr.trim().replace(',', '.');
    const match = clean.match(/^([\d.]+)\s*([A-Za-z]+)?$/);
    if (!match) return 0;
    const val = parseFloat(match[1]);
    const unit = (match[2] || 'B').toUpperCase();
    const multipliers = {
        'B': 1,
        'KB': 1024,
        'MB': 1024 * 1024,
        'GB': 1024 * 1024 * 1024,
        'TB': 1024 * 1024 * 1024 * 1024
    };
    return Math.round(val * (multipliers[unit] || 1));
}

let pendingMoveOperation = null;

function applyImmediateSizeUpdate() {
    if (pendingMoveOperation && pendingMoveOperation.targetName && pendingMoveOperation.draggedBytes > 0) {
        const newTotal = pendingMoveOperation.targetInitialBytes + pendingMoveOperation.draggedBytes;
        updateRowSizeInDOM(pendingMoveOperation.targetName, newTotal);
    }
}

function updateRowSizeInDOM(fileName, bytes) {
    if (!fileName || bytes === undefined || bytes === null) return;
    const formattedSize = formatBytes(bytes);
    
    // 1. Nextcloud 33 Vue Table Rows (.files-list__row, tr, div[data-cy-files-list-row])
    const allRows = document.querySelectorAll('tr, div[data-cy-files-list-row], .files-list__row');
    allRows.forEach(row => {
        const nameLink = row.querySelector('.files-list__row-name-link, .innernametext, .nametext, .name, [data-cy-files-list-row-name-link], a');
        const rowFileAttr = row.getAttribute('data-file') || row.getAttribute('data-entryname') || row.getAttribute('data-cy-files-list-row-name') || '';
        const rowName = (nameLink ? nameLink.textContent.trim() : '') || rowFileAttr;
        
        if (rowName === fileName) {
            const sizeCell = row.querySelector('.files-list__row-size, .filesize, .size, td.size, [data-cy-files-list-row-size], .file-size');
            if (sizeCell) {
                const span = sizeCell.querySelector('span');
                if (span) {
                    span.textContent = formattedSize;
                } else {
                    sizeCell.textContent = formattedSize;
                }
            }
            try {
                if (row.__vue__ && row.__vue__.source) {
                    row.__vue__.source.size = bytes;
                    if (row.__vue__.source.attributes) {
                        row.__vue__.source.attributes.size = bytes;
                    }
                }
            } catch (e) {}
        }
    });

    // 2. Direct attribute selectors
    try {
        const directSelectors = [
            `tr[data-file="${CSS.escape(fileName)}"]`,
            `tr[data-entryname="${CSS.escape(fileName)}"]`,
            `[data-file="${CSS.escape(fileName)}"]`
        ];
        for (const sel of directSelectors) {
            const elements = document.querySelectorAll(sel);
            elements.forEach(el => {
                const cell = el.querySelector('.files-list__row-size, .filesize, .size, td.size, [data-cy-files-list-row-size], .file-size');
                if (cell) {
                    const span = cell.querySelector('span');
                    if (span) {
                        span.textContent = formattedSize;
                    } else {
                        cell.textContent = formattedSize;
                    }
                }
            });
        }
    } catch (e) {}
}

async function updateFolderSizesFromWebDav() {
    try {
        const path = getCurrentDirectoryPath();
        const url = getWebDavUrl(path);
                
        const response = await axios({
            method: 'PROPFIND',
            url: url,
            headers: {
                'Depth': '1',
                'Content-Type': 'application/xml'
            }
        });
        
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response.data, 'application/xml');
        const responses = xmlDoc.getElementsByTagNameNS('DAV:', 'response');
        
        for (let i = 0; i < responses.length; i++) {
            const resp = responses[i];
            const hrefElem = resp.getElementsByTagNameNS('DAV:', 'href')[0] || resp.getElementsByTagName('href')[0] || resp.getElementsByTagName('d:href')[0];
            if (!hrefElem) continue;
            
            const href = decodeURIComponent(hrefElem.textContent);
            const pathParts = href.split('/').filter(Boolean);
            const fileName = pathParts[pathParts.length - 1];
            if (!fileName) continue;

            let sizeElem = resp.getElementsByTagNameNS('http://owncloud.org/ns', 'size')[0] ||
                           resp.getElementsByTagNameNS('http://nextcloud.org/ns', 'size')[0] ||
                           resp.getElementsByTagNameNS('DAV:', 'getcontentlength')[0] ||
                           resp.getElementsByTagName('oc:size')[0] ||
                           resp.getElementsByTagName('nc:size')[0] ||
                           resp.getElementsByTagName('size')[0] ||
                           resp.getElementsByTagName('getcontentlength')[0];
            
            if (sizeElem) {
                const sizeBytes = parseInt(sizeElem.textContent, 10);
                if (!isNaN(sizeBytes)) {
                    updateRowSizeInDOM(fileName, sizeBytes);
                }
            }
        }
    } catch (error) {
        console.error('Error updating folder sizes with WebDAV:', error);
    }
}

function refreshFileListAndStats() {
    try {
        // 1. Reload file list in legacy Nextcloud / OCA.Files.App
        if (typeof OCA !== 'undefined' && OCA.Files && OCA.Files.App && OCA.Files.App.fileList) {
            if (typeof OCA.Files.App.fileList.reload === 'function') {
                OCA.Files.App.fileList.reload();
            }
            if (typeof OCA.Files.App.fileList.updateStorageStats === 'function') {
                OCA.Files.App.fileList.updateStorageStats();
            }
        }

        // 2. Emit Nextcloud EventBus events for Vue / NC 28+ / NC 30+ / NC 33
        if (typeof window.OC !== 'undefined' && window.OC.EventBus) {
            window.OC.EventBus.emit('files:file-list:reload');
            window.OC.EventBus.emit('files:node:updated');
            window.OC.EventBus.emit('files:reload');
            window.OC.EventBus.emit('files:navigation:reload');
        }

        // 3. Update Nextcloud storage display if available
        if (typeof OC !== 'undefined' && OC.Files && typeof OC.Files.updateStorageStats === 'function') {
            OC.Files.updateStorageStats();
        }

        // 4. Update folder sizes directly in DOM from WebDAV PROPFIND
        setTimeout(async () => {
            await updateFolderSizesFromWebDav();
            if (typeof countFilesWithWebDav === 'function') {
                directoryFilesCount = await countFilesWithWebDav();
            }
        }, 300);
    } catch (e) {
        console.error('Error refreshing file list dynamically:', e);
    }
}

// Then modify your success function to use it:
window.filesTemplatesShowMoveSuccess = function() {
    if (!errorShown) {
        showSuccess(getSuccessMessage());
        errorShown = true;
        
        setTimeout(() => {
            errorShown = false;
        }, 3000);
        
        // Refresh file list and storage stats dynamically without full page reload
        if (!hasPendingOperations()) {
            refreshFileListAndStats();
        } else {
            console.log('Pending operations detected, delaying dynamic refresh...');
            const checkInterval = setInterval(() => {
                if (!hasPendingOperations()) {
                    clearInterval(checkInterval);
                    refreshFileListAndStats();
                }
            }, 1000);
        }
        
        return true;
    } else {
        return false;
    }
};

function getCustomMessage() {
    const lang = getUserLanguage();
    return translations.errorMessage[lang] || translations.errorMessage.en;
}

function getCustomTitle() {
    const lang = getUserLanguage();
    return translations.errorTitle[lang] || translations.errorTitle.en;
}

function getSuccessMessage() {
    const lang = getUserLanguage();
    
    if (typeof OC !== 'undefined' && OC.L10N) {
        return OC.L10N.translate('files', 'Files moved successfully') || 'Files moved successfully';
    }
    
    return 'Files moved successfully';
}

window.filesTemplatesShowMoveError = function(message) {
    if (!errorShown) {
        showError(
            message || getCustomMessage(),
            { title: getCustomTitle() }
        );
        errorShown = true;
        
        setTimeout(() => { 
            errorShown = false; 
        }, 3000);
        
        return true;
    } else {
        return false;
    }
};


function hideDefaultErrorDialog() {
    const dialogs = document.querySelectorAll('.oc-dialog');
    dialogs.forEach(dialog => {
        dialog.style.display = 'none';
        
        const backdrop = document.querySelector('.oc-dialog-dim');
        if (backdrop) {
            backdrop.style.display = 'none';
        }
    });
    
    const toasts = document.querySelectorAll('.toast-error, .toast, .toastify');
    toasts.forEach(toast => {
        toast.style.display = 'none';
    });
}

function getCurrentDirectoryPath() {
    let path = '/';
    
    const breadcrumbLinks = document.querySelectorAll('.breadcrumbs__crumb a, [data-cy-breadcrumb] a');
    if (breadcrumbLinks.length > 1) {
        const parts = Array.from(breadcrumbLinks).slice(1).map(a => a.textContent.trim()).filter(Boolean);
        if (parts.length > 0) {
            path = '/' + parts.join('/');
        }
    }
    
    if (path === '/' && typeof OC !== 'undefined' && OC.Files && OC.Files.App && OC.Files.App.currentFileList) {
        path = OC.Files.App.currentFileList.getCurrentDirectory() || '/';
    } 
    else if (path === '/') {
        const dirElem = document.querySelector('#app-content-files')?.dataset?.currentDirectory;
        if (dirElem) {
            path = dirElem;
        } else {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const dirParam = urlParams.get('dir');
                if (dirParam) {
                    path = decodeURIComponent(dirParam);
                }
            } catch (e) {
                console.error('Error parsing URL parameters:', e);
            }
        }
    }
    
    if (!path.startsWith('/')) {
        path = '/' + path;
    }
    
    if (!path.endsWith('/')) {
        path = path + '/';
    }
    
    return path;
}


function getWebDavUrl(path) {
    let uid = '';
    if (typeof OC !== 'undefined' && OC.getCurrentUser) {
        const user = OC.getCurrentUser();
        uid = user ? (user.uid || user) : '';
    }
    
    let webdavBase = '';
    if (typeof OC !== 'undefined' && OC.getRootPath) {
        webdavBase = uid 
            ? OC.getRootPath() + '/remote.php/dav/files/' + uid 
            : OC.getRootPath() + '/remote.php/webdav';
    } else {
        webdavBase = uid ? '/remote.php/dav/files/' + uid : '/remote.php/webdav';
    }
    
    path = path.replace(/\/+/g, '/');
    const full = (webdavBase + path).replace(/\/+/g, '/');
    return full;
}

async function countFilesWithWebDav() {
    try {
        const path = getCurrentDirectoryPath();
        const url = getWebDavUrl(path);
                
        const response = await axios({
            method: 'PROPFIND',
            url: url,
            headers: {
                'Depth': '1',
                'Content-Type': 'application/xml'
            }
        });
        
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response.data, 'application/xml');
        
        const responses = xmlDoc.getElementsByTagNameNS('DAV:', 'response');
        
        const count = responses.length > 0 ? responses.length - 1 : 0;
        
        return count;
    } catch (error) {
        console.error('Error counting files with WebDAV:', error);
        return null;
    }
}

async function handleMoveError(showMessage = true) {
    hideDefaultErrorDialog();
    
    if (!showMessage) {
        return;
    }
    
    try {
        const beforeCount = directoryFilesCount;
        
        directoryFilesCount = await countFilesWithWebDav();
        const currentCount = directoryFilesCount;
        
        
        if (currentCount !== null && beforeCount !== null) {
            if (currentCount !== beforeCount) {
                window.filesTemplatesShowMoveSuccess();
            } else {
                window.filesTemplatesShowMoveError();
            }
        } else {
            window.filesTemplatesShowMoveError();
        }
    } catch (error) {
        window.filesTemplatesShowMoveError();
    }
}

document.addEventListener('DOMContentLoaded', function() {
    
    document.addEventListener('dragstart', function(e) {
        const row = e.target.closest('tr, div[data-cy-files-list-row], .files-list__row');
        if (row) {
            const nameLink = row.querySelector('.files-list__row-name-link, .innernametext, .nametext, .name, [data-cy-files-list-row-name-link]');
            const rowName = (nameLink ? nameLink.textContent.trim() : '') || row.getAttribute('data-entryname') || row.getAttribute('data-file') || '';
            const sizeCell = row.querySelector('.files-list__row-size, .filesize, .size, td.size, [data-cy-files-list-row-size]');
            const sizeText = sizeCell ? sizeCell.textContent.trim() : '';
            const bytes = parseSizeToBytes(sizeText);

            pendingMoveOperation = {
                draggedName: rowName,
                draggedBytes: bytes,
                targetRow: null,
                targetName: null,
                targetInitialBytes: 0
            };
        }
    }, true);

    document.addEventListener('drop', function(e) {
        if (!pendingMoveOperation) return;
        const targetRow = e.target.closest('tr, div[data-cy-files-list-row], .files-list__row');
        if (targetRow) {
            const nameLink = targetRow.querySelector('.files-list__row-name-link, .innernametext, .nametext, .name, [data-cy-files-list-row-name-link]');
            const targetName = (nameLink ? nameLink.textContent.trim() : '') || targetRow.getAttribute('data-entryname') || targetRow.getAttribute('data-file') || '';
            const sizeCell = targetRow.querySelector('.files-list__row-size, .filesize, .size, td.size, [data-cy-files-list-row-size]');
            const sizeText = sizeCell ? sizeCell.textContent.trim() : '';
            const targetBytes = parseSizeToBytes(sizeText);

            pendingMoveOperation.targetRow = targetRow;
            pendingMoveOperation.targetName = targetName;
            pendingMoveOperation.targetInitialBytes = targetBytes;
        }
    }, true);
    
    setTimeout(async () => {
        try {
            const path = getCurrentDirectoryPath();
            
            directoryFilesCount = await countFilesWithWebDav();
        } catch (error) {
            console.error('Error getting initial file count:', error);
        }
    }, 1000);
    
    document.addEventListener('click', function(e) {
        const target = e.target;
        if (target.closest('[data-action="Move"]') || target.closest('[data-name="move"]')) {
            const fileRow = target.closest('.filerow');
            if (fileRow) {
                lastAttemptedFile = fileRow.dataset.filename || fileRow.getAttribute('filename');
            }
        }
    });
    
    const fetchOriginal = window.fetch;
    window.fetch = function(input, init) {
        const method = (init && init.method) || (typeof input === 'object' && input.method) || 'GET';
        return fetchOriginal.apply(this, arguments)
            .then(response => {
                if (response) {
                    if (method.toUpperCase() === 'MOVE' && (response.status === 201 || response.status === 204)) {
                        applyImmediateSizeUpdate();
                        setTimeout(() => {
                            updateFolderSizesFromWebDav();
                        }, 500);
                        setTimeout(() => {
                            updateFolderSizesFromWebDav();
                        }, 1500);
                    }
                    response.clone().text().then(text => {
                        if (text && (
                            text.includes('###CUSTOM_ERROR_STORAGE_MOVE###') ||
                            text.includes('###CUSTOM_ERROR_STORAGE_MOVE_PERMISSION###') ||
                            text.includes('###CUSTOM_SUCCESS_STORAGE_MOVE###')
                        )) {
                            setTimeout(() => {
                                hideDefaultErrorDialog();
                                
                                if (text.includes('###CUSTOM_SUCCESS_STORAGE_MOVE###')) {
                                    window.filesTemplatesShowMoveSuccess();
                                } else if (text.includes('###CUSTOM_ERROR_STORAGE_MOVE_PERMISSION###')) {

                                } else if (text.includes('###CUSTOM_ERROR_STORAGE_MOVE###')) {
                                    handleMoveError(true);
                                }
                            }, 500);
                        }
                    }).catch(() => {});
                }
                return response;
            });
    };
    
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
        const reqMethod = method || 'GET';
        this.addEventListener('load', function() {
            try {
                if (reqMethod.toUpperCase() === 'MOVE' && (this.status === 201 || this.status === 204)) {
                    applyImmediateSizeUpdate();
                    setTimeout(() => {
                        updateFolderSizesFromWebDav();
                    }, 500);
                    setTimeout(() => {
                        updateFolderSizesFromWebDav();
                    }, 1500);
                }
                const responseText = this.responseText;
                if (responseText && (
                    responseText.includes('###CUSTOM_ERROR_STORAGE_MOVE###') ||
                    responseText.includes('###CUSTOM_ERROR_STORAGE_MOVE_PERMISSION###') ||
                    responseText.includes('###CUSTOM_SUCCESS_STORAGE_MOVE###')
                )) {
                    setTimeout(() => {
                        hideDefaultErrorDialog();
                        
                        if (responseText.includes('###CUSTOM_SUCCESS_STORAGE_MOVE###')) {
                            window.filesTemplatesShowMoveSuccess();
                        } else if (responseText.includes('###CUSTOM_ERROR_STORAGE_MOVE_PERMISSION###')) {

                        } else if (responseText.includes('###CUSTOM_ERROR_STORAGE_MOVE###')) {
                            handleMoveError(true);
                        }
                    }, 500);
                }
            } catch (e) {}
        });
        return origOpen.apply(this, arguments);
    };
    
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                for (let i = 0; i < mutation.addedNodes.length; i++) {
                    const node = mutation.addedNodes[i];
                    if (node.nodeType === 1) {
                        if ((node.classList && (
                               node.classList.contains('oc-dialog') || 
                               node.classList.contains('oc-dialog-content') ||
                               node.classList.contains('toast-error') ||
                               node.classList.contains('toast') ||
                               node.classList.contains('toastify')
                           )) || 
                           (node.querySelector && (
                               node.querySelector('.toast-error') ||
                               node.querySelector('.oc-dialog') ||
                               node.querySelector('.toast') ||
                               node.querySelector('.toastify')
                           ))
                        ) {
                            if (node.textContent && (
                                node.textContent.includes('###CUSTOM_ERROR_STORAGE_MOVE###') ||
                                node.textContent.includes('###CUSTOM_ERROR_STORAGE_MOVE_PERMISSION###')
                            )) {
                                handleMoveError(true);
                            }
                        }
                    }
                }
            }
        });
    });
    
    observer.observe(document.body, { 
        childList: true, 
        subtree: true
    });
    
    const originalConsoleError = console.error;
    console.error = function() {
        const errorArgs = Array.from(arguments);
        const errorText = errorArgs.join(' ');
        
        if (
            errorText.includes('###CUSTOM_ERROR_STORAGE_MOVE###') ||
            errorText.includes('###CUSTOM_ERROR_STORAGE_MOVE_PERMISSION###') ||
            errorText.includes('###CUSTOM_SUCCESS_STORAGE_MOVE###')
        ) {
            hideDefaultErrorDialog();
            setTimeout(() => {
                if (errorText.includes('###CUSTOM_SUCCESS_STORAGE_MOVE###')) {
                    window.filesTemplatesShowMoveSuccess();
                } else if (errorText.includes('###CUSTOM_ERROR_STORAGE_MOVE_PERMISSION###')) {

                } else if (errorText.includes('###CUSTOM_ERROR_STORAGE_MOVE###')) {
                    handleMoveError(true);
                }
            }, 500);
        }
        
        originalConsoleError.apply(this, arguments);
    };
    
    window.addEventListener('error', function(e) {
        if (e.message && (
            e.message.includes('###CUSTOM_ERROR_STORAGE_MOVE###') ||
            e.message.includes('###CUSTOM_ERROR_STORAGE_MOVE_PERMISSION###') ||
            e.message.includes('###CUSTOM_SUCCESS_STORAGE_MOVE###')
        )) {
            setTimeout(function() {
                hideDefaultErrorDialog();
                
                if (e.message.includes('###CUSTOM_SUCCESS_STORAGE_MOVE###')) {
                    window.filesTemplatesShowMoveSuccess();
                } else if (e.message.includes('###CUSTOM_ERROR_STORAGE_MOVE_PERMISSION###')) {

                } else if (e.message.includes('###CUSTOM_ERROR_STORAGE_MOVE###')) {
                    handleMoveError(true);
                }
            }, 500);
            
            e.preventDefault();
        }
    }, true);
    
if (typeof OC !== 'undefined' && OC.Files && OC.Files.App) {
    OC.Files.App.on('changeDirectory', function() {
        setTimeout(async () => {
            const path = getCurrentDirectoryPath();
            directoryFilesCount = await countFilesWithWebDav();
        }, 1000);
    });
}

// Detect location change
let lastUrl = window.location.href;
const urlObserver = new MutationObserver(async function() {
    if (lastUrl !== window.location.href) {
        // console.log('URL changed from', lastUrl, 'to', window.location.href);
        lastUrl = window.location.href;
        
        setTimeout(async () => {
            const path = getCurrentDirectoryPath();
            directoryFilesCount = await countFilesWithWebDav();
        }, 1000);
    }
});

urlObserver.observe(document, { subtree: true, childList: true });

const directoryObserver = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
        if (mutation.type === 'attributes' && 
            (mutation.attributeName === 'data-current-directory' || 
             mutation.attributeName === 'data-directory')) {
            
            const newPath = mutation.target.getAttribute(mutation.attributeName);
            if (newPath) {
                setTimeout(async () => {
                    const path = getCurrentDirectoryPath();
                    directoryFilesCount = await countFilesWithWebDav();
                }, 1000);
            }
        }
    }
});


setTimeout(() => {
    const possibleContainers = [
        document.querySelector('#app-content-files'),
        document.querySelector('#app-content'),
        document.querySelector('.files-list'),
        document.querySelector('[data-cy-files-list]')
    ];
    
    for (const container of possibleContainers) {
        if (container) {
            directoryObserver.observe(container, { 
                attributes: true,
                attributeFilter: ['data-current-directory', 'data-directory']
            });
        }
    }
}, 1000);
});